// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__7jPap","logo":"Hero_logo__EVsm+"};